import React from 'react';
import { Section } from './Section';
import { motion } from 'framer-motion';
export function About() {
  return <Section id="about" title="About Me" data-id="element-14">
      <div className="max-w-3xl mx-auto" data-id="element-15">
        <motion.div className="space-y-6 text-lg text-gray-700 leading-relaxed" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-16">
          <p data-id="element-17">
            I am a Learning Experience Designer, Instructional Designer, and
            Digital Learning Strategist who specializes in facilitating
            trainings for individuals, educators, and organizations on how to
            leverage AI tools to save costs, drive efficiency, and maximize
            impact. With over 7 years of experience in learning design, youth
            engagement, and social impact, I have developed a proven track
            record of creating transformative learning programs that not only
            empower learners but also equip institutions and businesses to
            thrive in a digital-first, AI-powered future. My approach blends
            instructional design, strategic facilitation, and digital innovation
            to make education and organizational growth more accessible,
            scalable, and future-ready.
          </p>
          <p data-id="element-18">
            As a GIZ/GOPA-trained Trainer, Facilitator, and Coach, I am
            certified in implementing the globally recognized ICSS (Inspire,
            Create, Start, and Scale) Entrepreneurship Model. This equips me
            with a structured framework for teaching entrepreneurship, business
            innovation, and problem-solving—skills that I integrate into my
            AI-focused programs to help stakeholders transform challenges into
            opportunities. Whether it's designing curricula or building adaptive
            digital learning systems, my work bridges innovation with
            practicality to deliver measurable outcomes.
          </p>
          <p data-id="element-19">
            Beyond program design, I work directly with school owners,
            educators, young professionals, and organizations to embed AI and
            digital solutions into their processes—optimizing operations,
            enhancing teaching delivery, and accelerating organizational growth.
            My expertise in curriculum design, program development, and
            strategic facilitation allows me to support diverse stakeholders in
            building sustainable learning ecosystems that are resilient to the
            evolving demands of the future of work.
          </p>
          <p data-id="element-20">
            To date, I have impacted over 15,000 individuals across Africa and
            beyond through keynotes, trainings, and mentorship delivered on
            platforms such as TEDx Warri, TEDx University of Benin, YALI
            Network, PanAfrican Capital Foundation, and NIMSA. As founder of
            GoABitFurther Africa, I've provided mentorship and training to over
            5,000 young people in Nigeria, Namibia, and Kenya. I also curate The
            Networking Salon, a global salon-style professional community active
            in Lagos, Abuja, Benin, Warri, Berlin, and Houston—fostering
            collaboration, knowledge-sharing, and access to opportunities for
            professionals and entrepreneurs worldwide.
          </p>
        </motion.div>
      </div>
    </Section>;
}